import IoTriggerConfig from 'eflex/models/io-trigger-config';

export default class AdamIoTriggerConfig extends IoTriggerConfig {}
